// src/routes/OutletWithContext.tsx
import { Outlet, useOutletContext } from 'react-router-dom';

/**
 * OutletWithContext
 *
 * Preserves the parent outlet context across intermediate group/layout routes.
 * React Router v6 drops outlet context if a route renders its own <Outlet />.
 *
 * Use this component ONLY when a group route needs to forward outlet context.
 */
export default function OutletWithContext() {
  const ctx = useOutletContext<unknown>();
  return <Outlet context={ctx} />;
}
